import { http } from './http'
import type { ApiResponse, Car } from '../types/api'

interface ListParams {
  skip?: number;
  take?: number;
  sort?: string;
}

interface ListCarParams {
  skip?: number;
  take?: number;
  sort?: string;
  plateNumber?: string;
}

export const listCars = async (
  params: ListCarParams = {}
): Promise<{ list: Car[]; total: number }> => {
  // สร้าง query string
  const query = new URLSearchParams();

  if (params.skip != null) query.set("skip", String(params.skip));
  if (params.take != null) query.set("take", String(params.take));
  if (params.sort) query.set("sort", params.sort);
  if (params.plateNumber) query.set("plateNumber_like", params.plateNumber);

  const response = await http.get<ApiResponse<Car[]>>(`/cars?${query.toString()}`);

  const { data } = response;
  if (!data.success || !data.data) {
    throw new Error(data.error || "Load failed");
  }

  const total = Number(response.headers["x-total-count"] ?? 0);

  return { list: data.data, total };
}

export const getCar = async (id: number): Promise<Car> => {
  const { data } = await http.get<ApiResponse<Car>>(`/cars/${id}`)
  if (!data.success || !data.data) throw new Error(data.error || 'Load failed')
  return data.data
}

export const createCar = async (payload: Partial<Car>) => {
  const { data } = await http.post<ApiResponse<Car>>('/cars', payload)
  if (!data.success || !data.data) throw new Error(data.error || 'Create failed')
  return data.data
}

export const updateCar = async (id: number, payload: Partial<Car>): Promise<Car> => {
  const { data } = await http.put<ApiResponse<Car>>(`/cars/${id}`, payload)
  if (!data.success || !data.data) throw new Error(data.error || 'Create failed')
  return data.data
}

export const deleteCar = async (id: number): Promise<void> => {
  const { data } = await http.delete<ApiResponse<null>>(`/cars/${id}`);
  if (!data.success) throw new Error(data.error || "Delete car failed");
};
